import { Injectable, inject } from '@angular/core'
import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable, catchError, throwError } from 'rxjs'

import { AuthenticationService } from '@/app/core/service/auth.service'
import { CompanyContextService } from '@/app/services/http/company-context.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService)
  private companyContextService = inject(CompanyContextService)
  private router = inject(Router)

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.authenticationService.session

    if (token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    }

    return next.handle(request).pipe(
      catchError((err: unknown) => {
        // Only force a logout when a token we sent was rejected — a 401 on a
        // request that carried no token (e.g. an invalid invite code while
        // logged out) just means "this route needs auth", not "your session died".
        if (token && err instanceof HttpErrorResponse && err.status === 401) {
          this.authenticationService.logout()
          // logout() only clears the auth session — it deliberately doesn't know about
          // company selection. Clear it explicitly here too, otherwise the next login on
          // this browser (any account) would inherit this session's active company.
          this.companyContextService.clearActiveCompany()
          this.router.navigate(['/auth/log-in'])
        }
        return throwError(() => err)
      })
    )
  }
}

export const AuthInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
}
